module.exports = __webpack_public_path__ + "static/media/ai.2bb08d7d.svg";